module.exports = __webpack_public_path__ + "img/05.41364976.jpg";